<!-- Refactored single template with conditional button placement -->
<section class="card-checkout-success" [ngClass]="{'v2': isV2}">
  <div class="card-body">
    <h2 *ngIf="isV2" class="typography-h5">{{ data.title | translate}}</h2>
    <header class="card-header">
      <div class="card-header__check" [attr.data-type]="data.type || 'success'">
        <mat-icon *ngIf="!isV2" class="check-icon material-icons-outlined">{{ iconName }}</mat-icon>
        <mat-icon *ngIf="isV2" class="check-icon" [svgIcon]="'billing:' + iconName + '_twotone_blue'"></mat-icon>
      </div>
      <div class="card-header__content">
        <h2 *ngIf="!isV2" class="typography-h5">{{ data.title  | translate}}</h2>
        <p class="subtitle">{{ data.description | translate }}</p>

        <!-- Buttons in header for version 1 -->
        <div *ngIf="shouldShowHeaderButtons" fxLayout class="buttons-container">
          <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
        </div>

        <p *ngIf="errorMsg" class="card-header__content__error-msg">{{ errorMsg | translate }}</p>
      </div>
    </header>

    <div class="card-content">
      <div class="payment-summary">
        <h3 class="typography-subtitle1 bold">{{ data.paymentSummaryText | translate }}</h3>
        <div class="payment-summary__item user-price">
          <span>{{ ('billing.paymentSummary.newPlan' | translate) + ': ' + planSelected }}</span>
          <span class="right">{{ 'common.#users' | translate: { count: data.billableUsers } | lowercase }},<br
              ngClass.gt-xs="hidden">
            {{ formatLocalizedPrice(planInfo.unitPrice) }}
            {{ 'common.user' | translate | lowercase }}/{{ 'billing.' + planInfo.recurrence | translate }}</span>
        </div>
        <div class="payment-summary__item">
          <span>{{ totalAmountLabel | translate }}</span>
          <span class="total-amount">
            <b>{{ formatLocalizedPrice(data.totalAmount) }}</b>
            <em *ngIf="data.hasAddons" class="addon-fee-label">{{ 'billing.includeAddons' | translate }}</em>
          </span>
        </div>
      </div>

      <div class="payment-details">
        <div class="payment-details__item">
          <h4 [ngClass]="{'typography-body1 bold': isV2, 'typography-subtitle2': !isV2}">
            {{ titleDate | translate }}
          </h4>
          <span [ngClass]="{'typography-body2': isV2, 'typography-subtitle1': !isV2}">
            {{ paymentDate | date }}
          </span>
        </div>
        <div class="payment-details__item" data-testid="card-info-wrapper">
          <h4 [ngClass]="{'typography-body1 bold': isV2, 'typography-subtitle2': !isV2}">
            {{ paymentMethodTextKey | translate }}
          </h4>
          <div *ngIf="cardInfo" class="card-info-wrapper">
            <mat-icon *ngIf="!isV2" [svgIcon]="'cards:' + (cardInfo.cardBrand)"></mat-icon>
            <mat-icon *ngIf="isV2" [svgIcon]="'cards:' + (cardInfo.cardBrand) + '_no_border'"></mat-icon>
            <span [ngClass]="{'typography-body2': isV2, 'typography-subtitle1': !isV2}">
              *** *** *** {{ cardInfo.cardLastFour }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <footer class="card-footer" [innerHTML]="data.footerText "></footer>
  </div>

  <!-- Buttons below footer for version 2 -->
  <div *ngIf="shouldShowFooterButtons" fxLayout class="buttons-container buttons-below-footer">
    <ng-container *ngTemplateOutlet="buttonsTemplate"></ng-container>
  </div>
</section>

<!-- Reusable button template -->
<ng-template #buttonsTemplate>
  <button *ngIf="buttons?.action as actionBtn" mat-raised-button color="primary" class="typography-button2"
    (click)="actionBtn.onClick()" [trackClick]="actionBtn.trackingCtx">
    <ng-container *ngIf="!isLoadingAction; else loading">
      {{ actionBtn.text | translate}}
    </ng-container>
  </button>
  <button *ngIf="buttons?.dismiss as dismissBtn" mat-stroked-button class="typography-button2"
    (click)="dismissBtn.onClick()" [trackClick]="{ page: 'Clicked Cancel' }">
    {{ dismissBtn.text  | translate}}
  </button>
</ng-template>



<ng-template #loading>
  <mat-spinner class="spinner-white" diameter="20"></mat-spinner>
</ng-template>
